import parse from 'utils/parse';

const makeTestId = (...ids: string[]): string => parse.toTestId('landing', 'become-rich-banner', ...ids);

const testId = Object.freeze({
  component: makeTestId(),
});

const config = {
  numTopModels: 3,
  earnings: {
    gold: {
      rank: 1,
      amount: 3_432_379,
    },
    silver: {
      rank: 2,
      amount: 1_603_530,
    },
    bronze: {
      rank: 3,
      amount: 1_168_857,
    },
  },
};

export { testId, config };
